import React from 'react';
import { SEO } from '../../components/SEO';
import notFound from './notFound.png';
import notFound2x from './notFound_2x.png';
import styles from './notFoundPage.module.scss';

export const NotFound = () => {
  // SEO для страницы 404
  const seo = {
    title: '404 Not Found – GE Classique',
    description: 'This page does not exist on GE Classique. Return to the main page and join the classic Granado Espada adventure!',
    url: 'https://ge-classique.com/404',
    image: 'https://ge-classique.com/logo192.png'
  };
  return (
    <>
      <SEO {...seo} />
      <div className={styles.wrapper}>
        <div className={styles.block}>
        <div className={styles.titleWrap}>
          <div className={styles.title}>404 Not Found</div>
        </div>
        <img className={styles.notFoundImg} src={notFound} srcSet={`${notFound2x} 2x`} alt="notFound" />
      </div>
    </div>
    </>
  );
};
